import styles from '../../assets/styles/Components/AppPage.module.scss';
import Sidebar from '../Sidebar';
import { LogoutContainer } from '../../containers';
import { AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import constant from '../../utils/constant';
import { FaBars } from 'react-icons/fa';
import React, { useState } from 'react';
import IconButton from '../IconButton';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';

const propTypes = {
	children: PropTypes.any,
	pageTitle: PropTypes.string,
	tradingName: PropTypes.string,
};
const defaultProps = {
	pageTitle: '',
};

const AppPage = ({ children, pageTitle, tradingName, ...props }) => {
	const [showSidebar, setShowSidebar] = useState(false);

	const navigate = useNavigate();
	const goToSettings = () => {
		navigate(constant.Routes.Settings);
	};

	const [logoutModal, setLogoutModal] = useState(false);

	const goTologout = () => {
		setLogoutModal(true);
	};

	const closeModal = () => {
		setLogoutModal(false);
	};

	const menuClicked = () => {
		setShowSidebar(!showSidebar);
	};


	return (
		<div className={styles.container} {...props}>
			{showSidebar && (
				<motion.div
					initial={{
						opacity: 0,
					}}
					animate={{
						opacity: 1,
						transition: {
							duration: 0.2,
						},
					}}
					exit={{
						opacity: 0,
						transition: {
							duration: 0.2,
						},
					}}
					className={styles.sidebar}
				>
					<motion.div
						initial={{
							x: -100,
						}}
						animate={{
							x: 0,
							transition: {
								duration: 0.2,
							},
						}}
						exit={{
							x: -100,
							transition: {
								duration: 0.2,
							},
						}}
					>
						<Sidebar menuClicked={menuClicked}/>
					</motion.div>
					<div onClick={menuClicked}></div>
				</motion.div>
			)}

			<div className={styles.topside}>
				<div  className={styles.topside_left}>
					<FaBars className={styles.menuIcon} onClick={menuClicked} />
					{pageTitle !== '' ? (
						<h3> {pageTitle} </h3>
					) : (
						<p className={styles.topside_welcome}>
							Welcome back, <br />
							<span className={styles.topside_name}>{tradingName ? tradingName : "Admin"}</span>
						</p>
					)}
				</div>


				<div className={styles.topside_icon}>
					<IconButton onClick={goToSettings} />
					<IconButton variant="logout" onClick={goTologout} />
				</div>

			</div>
			<div>
				{children}
			</div>


			{logoutModal && (
				<div className="modal">
					<AnimatePresence>
						{logoutModal && <LogoutContainer closeModal={closeModal} />}
					</AnimatePresence>
				</div>
			)}
		</div>
	);
};

AppPage.propTypes = propTypes;

AppPage.defaultProps = defaultProps;

export default AppPage;
